export default function validation(response, messages, preMessage = null) {
  if (!response.data.error || !response.data.error.validationErrors) {
    return;
  }
  response.data.error.validationErrors.forEach((error) => {
    const message = error.message;
    if (message.indexOf('SECTEUR_NOT_MATCH') !== -1) {
      messages.push({ message: 'addSecteurLien.validation.noSecteurMatch', preMessage });
    }
  });
}
